import React, {Component} from 'react';
import {Table} from 'antd';

class ixTable extends Component {
	constructor(props) {
		super(props);
		const tableData = this.props.tableData;
		const selectedRowKeys = [];
		for(let i = 0; i < tableData.length; i++)
			selectedRowKeys.push(i.toString());
		this.state = {
			loading: false,
			selectedRowKeys: selectedRowKeys
		};
		this.props.selectedRowKeys(selectedRowKeys);
	}

	start = () => {
		this.setState({loading: true});
		// ajax request after empty completing
		setTimeout(() => {
			this.setState({
				selectedRowKeys: [],
				loading: false,
			});
		}, 1000);
	};

	onSelectChange = (selectedRowKeys) => {
		console.log('selectedRowKeys changed: ' + selectedRowKeys);
		this.setState({selectedRowKeys: selectedRowKeys});
		this.props.selectedRowKeys(selectedRowKeys);
	};

	render() {
		const {selectedRowKeys} = this.state;
		const rowSelection = null;
		const hasSelected = selectedRowKeys.length > 0;
		return (
			<div>
				<Table size="small" pagination={this.props.pagination} rowSelection={rowSelection} columns={this.props.columns} dataSource={this.props.tableData} scroll={{ y: 240 }} />
				<div >
		          <span style={{marginLeft: 8}}>
		            {hasSelected? selectedRowKeys.length + ' files selected': ''}
		          </span>
				</div>
			</div>
		);
	}
}

export default ixTable;


// WEBPACK FOOTER //
// ./src/components/Table.js